
<script>

   import { mapActions } from "vuex";

   export default {
   name: "popupsAlertsAuth",
   props: ['data'],
   data() {
      return {
      }
   },
   computed: {},
   methods: {
   ...mapActions("htmlModals", ["setConnectionError"]),
   setSetConnectionError(){
      document.getElementsByClassName('topBar')[0].style.position = "relative";
      this.setConnectionError(false);
   }
   },
   mounted(){},
   created(){
      console.log(this.data);
   }
}

</script>

<template>
<div class="modalWrapper">
<div class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">

<div  class="ui grid centered stackable">
   <div class="ten wide column" >
      <div style="padding: 0;" @click="setSetConnectionError()"  class="ui basic segment right aligned">
      <a style="background: rgba(0,0,0,0.6); position:relative; z-index:9999" class="ui black mini button">Close [ESC]</a>
      </div>
   </div>
</div>

   <div class="ui grid">
   <div style="background: #f1f1f1; border-radius: 0.5rem;" class="ten wide column centered">
      <div v-if="data.id == 'instagram'" class="ui basic huge segment">
         <h2>Instagram Direct Message permission issue!</h2>
         <div class="ui divider"></div>
         <p>It seems like this page <b>{{data.page.name}}</b> does not have active Direct Message permissions at Instagram account settings.</p>
         <img class="ui image fluid" src="https://juphy.com/wp-content/uploads/2022/07/1632743995315-ig-settings.png" alt="Instagram">
         <p>1- Login to your Instagram business account from your mobile app and follow the steps mentioned in image above.</p>
         <p>2- When you activate permissions, get back to Juphy and go to channels settings and re-authenticate(re-connect) your Instagram channels.</p>
         <p>3- When Instagram channels are re-connected, the warnning sign (⚠️) should go away. ✅</p>
      </div>
      <div v-if="data.id == 'default'" class="ui basic huge segment">
         <h2>The Access Token Expired</h2>
         <div class="ui divider"></div>
         <p>1- Go to channels settings from left-side bar..</p>
         <p>2- Re-connect the channels and the problem should be solved when the channels re-connected.</p>
      </div>
   </div>
   </div>

   </div>
</div>
</template>


<style scoped>

      .modalWrapper {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         z-index: 99999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
      .modalWrapper div {
         z-index: 99999;
      }
      .modal {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         background: rgba(41, 50, 84, 0.738) none repeat scroll 0% 0%; 
         z-index: 9999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
</style>





// WEBPACK FOOTER //
// src/components/dashboard/popups/alerts/auth.vue